/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: ba8cfc219d76
 */

import * as z from "zod";

export type ApiErrorError = { message: string };

export const ApiErrorError$zodSchema: z.ZodType<ApiErrorError> = z.object({
  message: z.string(),
});

export type ApiError = { error: ApiErrorError };

export const ApiError$zodSchema: z.ZodType<ApiError> = z.object({
  error: z.lazy(() => ApiErrorError$zodSchema),
});
